<!-- results-table.component.html -->
<h1 mat-dialog-title></h1>
<div mat-dialog-content fxLayout="column">

  <div fxLayout="column" fxFlex="100" class="print">


      <div fxLayout="row" class="p-20">

        <div fxFlex fxLayout="row">
            <div fxFlex="50"><strong>{{organizacion}}</strong></div>
            <div fxFlex="50" fxLayout="column">
                            <div fxFlex fxLayoutAlign="end start">
                <img class="logo-icon" src="assets/images/logos/logo_RIC_horizontal_transparente.png" height="67" width="200" >
              </div>
              <div fxFlex fxLayoutAlign="end start" style="margin-right:20px">
                {{fecha | date:'dd/MM/yyyy'}}
              </div>
          </div>
        </div>
      </div>

      <div>
        <h1 class="p-20"><strong>Marco de referencia</strong></h1>
      </div>

      <div fxLayout="row" class="p-20">

        <div fxFlex fxLayout="column">
            <div fxFlex="100"><strong>Nombre: </strong>{{LOCAL_DATA.nombre}}</div>
        </div>
      </div>


  <div class="content p-24" fxFlex="100">

    <div fxLayout="row" >

      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <!-- This is the tree node template for leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
          <!-- use a disabled button to provide padding for tree leaf -->
          <button mat-icon-button disabled></button>
          <span style="font-weight: bold;margin-right:5px;">{{node.name}}</span>
          <span *ngIf="node.descripcion!=null && node.descripcion!=''" style="margin-right:5px;"> | {{node.descripcion}}</span>
          <!--
          <span *ngIf="node.usuarios!=null && node.usuarios.length>0" style="font-weight: bold;margin-right:5px;"> | </span>
          <mat-chip-list aria-label="Usuarios" *ngIf="node.usuarios!=null && node.usuarios.length>0">
            <mat-chip *ngFor="let usuario of node.usuarios">{{usuario.nombreCompleto}}</mat-chip>
          </mat-chip-list>-->
        </mat-tree-node>
        <!-- This is the tree node template for expandable nodes -->
        <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
          <button mat-icon-button matTreeNodeToggle
                  [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <span style="font-weight: bold;margin-right:5px;">{{node.name}}</span>
          <span *ngIf="node.descripcion!=null && node.descripcion!=''" style="margin-right:5px;"> | {{node.descripcion}}</span>
          <!--
          <span *ngIf="node.usuarios!=null && node.usuarios.length>0" style="font-weight: bold;margin-right:5px;"> | </span>
          <mat-chip-list aria-label="Usuarios" *ngIf="node.usuarios!=null && node.usuarios.length>0">
            <mat-chip *ngFor="let usuario of node.usuarios">{{usuario.nombreCompleto}}</mat-chip>
          </mat-chip-list>-->
        </mat-tree-node>
      </mat-tree>

    </div>

  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="printPdf()" [disabled]="disabled">{{'Imprimir' | translate}}</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
